export const updateUserSelector = ({ user }) => user;
